/* Serena — interacciones propias (prefijo mt-). Todo vanilla. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparadores() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
      if (comp.dataset.mtListo) return;
      comp.dataset.mtListo = '1';
      var rango = comp.querySelector('.mt-comparador__rango');
      if (!rango) return;
      var set = function () { comp.style.setProperty('--pos', rango.value + '%'); };
      rango.addEventListener('input', set);
      set();
    });
  }

  function formatMoney(cents, formato) {
    var n = (cents / 100);
    var conDec = n.toFixed(2);
    var partes = conDec.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = formato || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles)
      .replace(/\{\{\s*amount\s*\}\}/, miles + '.' + partes[1]);
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      if (root.dataset.mtListo) return;
      root.dataset.mtListo = '1';

      // Galería
      var principal = root.querySelector('.mt-pp__principal img');
      root.querySelectorAll('.mt-pp__mini').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.dataset.src;
            principal.srcset = '';
            principal.alt = btn.dataset.alt || '';
            principal.style.opacity = '1';
          }, 180);
          root.querySelectorAll('.mt-pp__mini').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });

      // Cantidad
      var qty = root.querySelector('.mt-cantidad input');
      root.querySelectorAll('.mt-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = parseInt(qty.value, 10) || 1;
          v = b.dataset.op === 'mas' ? v + 1 : Math.max(1, v - 1);
          qty.value = v;
        });
      });

      // Variantes
      var dataEl = root.querySelector('[data-mt-variantes]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var formato = root.dataset.moneyFormat;
      var idInput = root.querySelector('input[name="id"]');
      var boton = root.querySelector('[data-mt-anadir]');
      var botonTxt = boton ? boton.querySelector('span') : null;
      var precioEl = root.querySelector('[data-mt-precio]');
      var tachadoEl = root.querySelector('[data-mt-tachado]');
      var barraPrecio = document.querySelector('[data-mt-barra-precio]');

      root.querySelectorAll('.mt-pp__opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          root.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            sel.push(c ? c.value : null);
            var lbl = fs.querySelector('legend span');
            if (lbl && c) lbl.textContent = c.value;
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === sel[i]; });
          });
          if (!v) {
            if (boton) boton.disabled = true;
            if (botonTxt) botonTxt.textContent = boton.dataset.noDisponible;
            return;
          }
          if (idInput) idInput.value = v.id;
          if (precioEl) precioEl.textContent = formatMoney(v.price, formato);
          if (barraPrecio) barraPrecio.textContent = formatMoney(v.price, formato);
          if (tachadoEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              tachadoEl.textContent = formatMoney(v.compare_at_price, formato);
              tachadoEl.hidden = false;
            } else { tachadoEl.hidden = true; }
          }
          if (boton) {
            boton.disabled = !v.available;
            if (botonTxt) botonTxt.textContent = v.available ? boton.dataset.textoOk : boton.dataset.agotado;
          }
          if (v.featured_image && principal) {
            principal.src = v.featured_image;
            principal.srcset = '';
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });

    // Barra fija de compra en móvil
    var barra = document.querySelector('.mt-pp__barra');
    var ancla = document.querySelector('[data-mt-anadir]');
    if (barra && ancla && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('mt-visible', pasado);
        });
      }).observe(ancla);
      var ir = barra.querySelector('[data-mt-ir-comprar]');
      if (ir) ir.addEventListener('click', function (ev) {
        ev.preventDefault();
        ancla.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  function initTodo() { initReveal(); initComparadores(); initProducto(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  // Editor de Shopify: re-inicializa al cambiar secciones
  document.addEventListener('shopify:section:load', initTodo);
})();
